import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=3fa853ba&scoped=true"
var script = {}
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=3fa853ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa853ba",
  null
  
)

export default component.exports